var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"app",attrs:{"id":"app"}},[(_vm._showLogo)?_c('div',{staticClass:"d-flex justify-center align-center fill-width pt-10"},[_c('v-img',{attrs:{"src":require('@/assets/logo.png'),"max-width":"20rem"}})],1):_vm._e(),_c('v-main',[_c('router-view')],1),_c('AlertBar',{ref:"alertBar"}),_c('VersionBadge')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }